import { Box } from "@chakra-ui/react";
import BackButton from "components/BackButton";
import HomeBackground from "components/HomeBackground";
import LayoutWrapper from "components/LayoutWrapper";
import { observer } from "mobx-react";
import { useMedia } from "react-use";
import { formatToString } from "utils/format";
import BottlingForm from "./components/BottlingForm";
import OrderHeader from "./components/OrderHeader";

const BottlingOrderPage = () => {
  const isMobile = useMedia("(max-width: 51.25em)");

  return (
    <Box h="full" pos="relative" mt={isMobile ? "50px" : undefined}>
      <HomeBackground />
      <LayoutWrapper>
        <Box
          minW={isMobile ? "full" : 1024}
          maxW={isMobile ? "full" : 1024}
          pt={4}
          pb={8}
        >
          <BackButton />
          <OrderHeader title={formatToString("cask.orders.bottling.title")} />
          <Box display="flex" w="full">
            <BottlingForm />
          </Box>
        </Box>
        <Box maxW={isMobile ? "full" : 512} w="full" />
      </LayoutWrapper>
    </Box>
  );
};

export default observer(BottlingOrderPage);
